var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.75 4.3144H1.25M7.38889 0.536621V2.42551M3.61111 0.536621V2.42551M3.51667 9.98107H7.48333C8.27674 9.98107 8.67344 9.98107 8.97649 9.82666C9.24305 9.69084 9.45977 9.47412 9.59559 9.20755C9.75 8.90451 9.75 8.50781 9.75 7.7144V3.74773C9.75 2.95432 9.75 2.55762 9.59559 2.25458C9.45977 1.98802 9.24305 1.77129 8.97649 1.63547C8.67344 1.48107 8.27674 1.48107 7.48333 1.48107H3.51667C2.72326 1.48107 2.32656 1.48107 2.02351 1.63547C1.75695 1.77129 1.54023 1.98802 1.40441 2.25458C1.25 2.55762 1.25 2.95432 1.25 3.74773V7.7144C1.25 8.50781 1.25 8.90451 1.40441 9.20755C1.54023 9.47412 1.75695 9.69084 2.02351 9.82666C2.32656 9.98107 2.72326 9.98107 3.51667 9.98107Z",
    stroke: "#505050",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.159170461a74f99a242c52a532f25656.svg";
export { ForwardRef as ReactComponent };